export default __webpack_public_path__ + "static/media/cars.ee79b532.png";